<template>
  <TrainerLayout>
    <div class="mx-0 px-0 md:px-6 lg:px-0 mb-4">
      <h3 class="uppercase py-4 mt-4 text-2xl font-bold">Upcoming Classes</h3>
      <MySessionsCard
        :data="trainerUpcomingSessionsData"
        :statusCode="
          trainerUpcomingSessions && trainerUpcomingSessions.statusCode
        "
      />
      <Pagination
        v-if="trainerUpcomingSessionsData.length"
        :currentPage="currentPage"
        :handlePageChange="handlePageChange"
        :totalPages="totalPages"
      />
    </div>
  </TrainerLayout>
</template>

<script>
import TrainerLayout from "@/components/layouts/TrainerLayout";
import MySessionsCard from "@/components/MySessionsCard";
import { Pagination } from "@/components/t-components";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "SessionUpcoming",
  components: {
    TrainerLayout,
    MySessionsCard,
    Pagination,
  },
  data() {
    return {
      trainerUpcomingSessionsData: [],
      currentPage: 1,
      per_page: 16,
      totalPages: "",
    };
  },
  computed: {
    ...mapGetters(["trainerUpcomingSessions"]),
  },
  methods: {
    ...mapActions(["getTrainerUpcomingSessions"]),

    async handlePageChange(page) {
      this.currentPage = page;
      const query = {
        per_page: this.per_page,
        page,
      };
      this.trainerUpcomingSessionsData = [];
      await this.getTrainerUpcomingSessions({ query });
      this.trainerUpcomingSessionsData =
        (this.trainerUpcomingSessions.data &&
          this.trainerUpcomingSessions.data.data) ||
        [];
    },
  },
  async created() {
    const query = {
      per_page: this.per_page,
      page: this.currentPage,
    };
    await this.getTrainerUpcomingSessions({ query });
    this.trainerUpcomingSessionsData =
      (this.trainerUpcomingSessions.data &&
        this.trainerUpcomingSessions.data.data) ||
      [];
    this.totalPages = this.trainerUpcomingSessions.last_page;
  },
};
</script>